<template>
  <div class="p-contentplans-writing-user-headings-item">
    <div
      class="p-contentplans-writing-user-headings-item__inner"
      :class="{ 'is-alert': error }"
    >
      <p class="p-contentplans-writing-user-headings-item__label">
        <HeadingType level="h1" />
      </p>
      <div class="p-contentplans-writing-user-headings-item__input c-alertPos">
        <Input
          :value="value"
          placeholder="AIが生成したテキストをここで編集できます"
          @input="input"
        />
        <Alert v-if="error">{{ error }}</Alert>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/Alert';
import HeadingType from '@/components/HeadingType';
import Input from '@/components/Input';

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    error: {
      type: String,
      required: false
    },
    value: {
      type: String,
      required: true
    }
  },
  components: {
    Alert,
    HeadingType,
    Input
  },
  methods: {
    input(value) {
      this.$emit('input', value);
    }
  }
};
</script>
